import { useEffect } from 'react';

import { ActionCreatorWithPayload } from '@reduxjs/toolkit';

import { useAppDispatch } from '../../../store/hooks';
import { PaginationDefaultsModel } from '../../models/pagination-defaults.model';
import { PaginationDefaults } from '../../utils/pagination-defaults.util';

export const useResetPageNumberAfterFiltering = (
  totalCount: number,
  page: number,
  rowsPerPage: number,
  resetPaginationThunk: ActionCreatorWithPayload<
    PaginationDefaultsModel,
    string
  >
): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (totalCount !== 0 && totalCount <= page * rowsPerPage) {
      dispatch(
        resetPaginationThunk({
          offset: PaginationDefaults.offset,
          size: rowsPerPage,
          pageNumber: PaginationDefaults.pageNumber,
          totalCount: PaginationDefaults.totalCount,
        })
      );
    }
  }, [totalCount, page, rowsPerPage]);
};
